export class Arbeitsbereich {
  readonly id: string;
  readonly name: string;
  readonly markierung: string;
  readonly abteilungen?: Abteilung[];

  constructor({
    id,
    name,
    markierung,
    abteilungen,
  }: {
    id: string;
    name: string;
    markierung: string;
    abteilungen?: Abteilung[];
  }) {
    this.id = id;
    this.name = name;
    this.markierung = markierung;
    this.abteilungen = abteilungen;
  }
}

export class Abteilung {
  readonly id: string;
  readonly name?: string;
  readonly markierung?: string;

  constructor({
    id,
    name,
    markierung,
  }: {
    id: string;
    name?: string;
    markierung?: string;
  }) {
    this.id = id;
    this.name = name;
    this.markierung = markierung;
  }
}
